import { environment } from '@env/environment';

/**
 * Logueo del front, con el mismo estilo que el back: `[Área] Mensaje en español: clave=valor`,
 * sin emojis ni punto final, y el error (si hay) como último argumento.
 *
 * - En prod sólo salen warn y error; debug e info quedan para desa y local.
 * - Es el único lugar que escribe en la consola (la regla `no-console` lo exige): cuando se sume
 *   Sentry, se conecta acá.
 *
 * Niveles, igual que en el back: error sólo para lo que alguien tiene que mirar; warn para
 * situaciones esperadas (sin conexión, sesión vencida, datos que faltan).
 */
type Level = 'debug' | 'info' | 'warn' | 'error';

const ORDER: Record<Level, number> = { debug: 0, info: 1, warn: 2, error: 3 };
const MIN_LEVEL: Level = environment.production ? 'warn' : 'debug';

function write(level: Level, area: string, message: string, details: unknown[]): void {
  if (ORDER[level] < ORDER[MIN_LEVEL]) {
    return;
  }
  // eslint-disable-next-line no-console
  console[level](`[${area}] ${message}`, ...details);
}

export const logger = {
  debug: (area: string, message: string, ...details: unknown[]) =>
    write('debug', area, message, details),
  info: (area: string, message: string, ...details: unknown[]) =>
    write('info', area, message, details),
  warn: (area: string, message: string, ...details: unknown[]) =>
    write('warn', area, message, details),
  error: (area: string, message: string, ...details: unknown[]) =>
    write('error', area, message, details),
  /** Sale también en prod: sólo para la línea de versión al arrancar. */
  version: (message: string) => {
    // eslint-disable-next-line no-console
    console.info(message);
  },
};
